import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "material-detail"
};
const _hoisted_2 = {
  class: "flex justify-center"
};
const _hoisted_3 = {
  class: "flex flex-column justify-center align-center",
  style: {
    "padding-bottom": "100px"
  }
};
const _hoisted_4 = ["innerHTML"];
import { onMounted, ref } from 'vue';
import { getMaterialDetail } from '@/api/material';
import { useRoute } from 'vue-router';
export default {
  __name: 'detail',
  setup(__props) {
    const route = useRoute();
    const loading = ref(false);
    const materialDetail = ref({});
    const _getMaterialDetail = async () => {
      loading.value = true;
      const res = await getMaterialDetail(route.params.id);
      materialDetail.value = res;
      loading.value = false;
    };
    onMounted(() => {
      _getMaterialDetail();
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never"
      }, {
        header: _withCtx(() => [_createElementVNode("h3", _hoisted_2, _toDisplayString(materialDetail.value.title), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
          src: materialDetail.value.cover,
          style: {
            "width": "100px",
            "margin": "50px 0"
          },
          fit: "cover",
          alt: "string"
        }, null, 8, ["src"]), _createElementVNode("div", {
          innerHTML: materialDetail.value.content
        }, null, 8, _hoisted_4)])]),
        _: 1
      })), [[_directive_loading, loading.value]])]);
    };
  }
};